import axios, { AxiosInstance } from 'axios';
import { apiRosterURL, mockAndDevelopment } from '../../app.config';

const rosterClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiRosterURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default rosterClient;
